import { render } from "./WidgetBetriebsmitteilungen.vue?vue&type=template&id=97fb1d58&scoped=true&ts=true"
import script from "./WidgetBetriebsmitteilungen.vue?vue&type=script&lang=ts"
export * from "./WidgetBetriebsmitteilungen.vue?vue&type=script&lang=ts"

import "./WidgetBetriebsmitteilungen.vue?vue&type=style&index=0&id=97fb1d58&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fb1d58"]])

export default __exports__